var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      class: ["dc-post-grid-card", "course-card"],
      attrs: { id: _vm.id },
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.goToPost()
        }
      }
    },
    [
      _c("div", { ref: "cardContentWrapper", staticClass: "content-wrapper" }, [
        _c("div", { staticClass: "content-wrapper__inner" }, [
          _vm.image
            ? _c("img", {
                attrs: {
                  src: _vm.image.src,
                  alt: _vm.image.alt,
                  srcset: _vm.image.srcset
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper__inner" }, [
            _c("h2", { staticClass: "content-wrapper__inner__title" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _vm.excerpt
              ? _c("p", { staticClass: "content-wrapper__inner__excerpt" }, [
                  _vm._v(_vm._s(_vm.excerpt))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "" } }, [
            _vm._v(_vm._s(_vm.dctxt("lesMerAlt")))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }